var getRedirectTo = function (languageCode) {
    return "https://" + (languageCode === 'en' ? '' : languageCode + ".") + "wix.com" + window.location.pathname + window.location.search;
};
export var getLanguageLinkHref = function (isLoggedIn, languageCode) {
    var redirectTo = getRedirectTo(languageCode);
    return isLoggedIn
        ? "https://users.wix.com/wix-users/auth/setLanguage?language=" + languageCode + "&redirectTo=" + encodeURIComponent(redirectTo)
        : redirectTo;
};
//# sourceMappingURL=utils.js.map